"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MainLayout = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _useTimeRange2 = _interopRequireDefault(require("../../hooks/use-time-range.js"));

var _ControllableWave = _interopRequireDefault(require("../ControllableWave"));

var _DurationBoxes = _interopRequireDefault(require("../DurationBoxes"));

var _useEventCallback = _interopRequireDefault(require("use-event-callback"));

var _seamlessImmutable = require("seamless-immutable");

var _useColors = _interopRequireDefault(require("../../hooks/use-colors"));

var _Timeline = _interopRequireDefault(require("../Timeline"));

var _getMinorMajorDurationLines = _interopRequireDefault(require("../../utils/get-minor-major-duration-lines"));

var _initTopLevelMatrix = _interopRequireDefault(require("../../utils/init-top-level-matrix"));

var _Toolbar = _interopRequireDefault(require("../Toolbar"));

var _useGetRandomColorUsingHash = _interopRequireDefault(require("../../hooks/use-get-random-color-using-hash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Container = (0, _styles.styled)("div")(function (_ref) {
  var themeColors = _ref.themeColors,
      width = _ref.width;
  return {
    width: width,
    display: "flex",
    flexDirection: "column",
    backgroundColor: themeColors.bg,
    padding: 16,
    boxSizing: "border-box"
  };
});
var defaultEnabledTools = ["create-durations", "label-durations", "create-timestamps", "label-timestamps"];

var MainLayout = function MainLayout(_ref2) {
  var curveGroups = _ref2.curveGroups,
      timeFormat = _ref2.timeFormat,
      durationGroups = _ref2.durationGroups,
      onChangeDurationGroups = _ref2.onChangeDurationGroups,
      _ref2$timestampLabels = _ref2.timestampLabels,
      timestampLabels = _ref2$timestampLabels === void 0 ? [] : _ref2$timestampLabels,
      _ref2$durationLabels = _ref2.durationLabels,
      durationLabels = _ref2$durationLabels === void 0 ? [] : _ref2$durationLabels,
      allowCustomLabels = _ref2.allowCustomLabels,
      timestamps = _ref2.timestamps,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 500 : _ref2$width,
      _ref2$graphHeight = _ref2.graphHeight,
      graphHeight = _ref2$graphHeight === void 0 ? 300 : _ref2$graphHeight,
      onChangeTimestamps = _ref2.onChangeTimestamps,
      _ref2$enabledTools = _ref2.enabledTools,
      enabledTools = _ref2$enabledTools === void 0 ? defaultEnabledTools : _ref2$enabledTools,
      _ref2$showValues = _ref2.showValues,
      showValues = _ref2$showValues === void 0 ? false : _ref2$showValues,
      onStartPlayback = _ref2.onStartPlayback,
      onStopPlayback = _ref2.onStopPlayback,
      isPlayingMedia = _ref2.isPlayingMedia;
  var themeColors = (0, _useColors.default)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeDurationGroup = _useState2[0],
      setActiveDurationGroup = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      draggedDurationIndex = _useState4[0],
      setDraggedDurationIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedDurationIndex = _useState6[0],
      setSelectedDurationIndex = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedTimestampIndex = _useState8[0],
      setSelectedTimestampIndex = _useState8[1];

  var _useState9 = (0, _react.useState)(function () {
    return (0, _initTopLevelMatrix.default)({
      curveGroups: curveGroups,
      width: width
    });
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      topLevelMatrix = _useState10[0],
      setTopLevelMatrix = _useState10[1];

  var _useTimeRange = (0, _useTimeRange2.default)(topLevelMatrix, width),
      visibleTimeStart = _useTimeRange.visibleTimeStart,
      visibleTimeEnd = _useTimeRange.visibleTimeEnd;

  var onDragDuration = (0, _useEventCallback.default)(function (startTime, endTime) {
    if (!enabledTools.includes("create-durations")) return;
    if (activeDurationGroup === null) return;

    var _ref3 = startTime < endTime ? [startTime, endTime] : [endTime, startTime];

    var _ref4 = _slicedToArray(_ref3, 2);

    startTime = _ref4[0];
    endTime = _ref4[1];
    if (selectedDurationIndex !== draggedDurationIndex) setSelectedDurationIndex(selectedDurationIndex);
    onChangeDurationGroups((0, _seamlessImmutable.setIn)(durationGroups, [activeDurationGroup, "durations", draggedDurationIndex], {
      start: startTime,
      end: endTime
    }));
  });
  var onDragDurationStart = (0, _useEventCallback.default)(function (startTime) {
    if (!enabledTools.includes("create-durations")) return;
    if (activeDurationGroup === null) return;
    var lastIndex = durationGroups[activeDurationGroup].durations.length;
    setDraggedDurationIndex(lastIndex);
    onChangeDurationGroups((0, _seamlessImmutable.setIn)(durationGroups, [activeDurationGroup, "durations", lastIndex], {
      start: startTime,
      end: startTime
    }));
  });
  var onDragDurationEnd = (0, _useEventCallback.default)(function () {
    if (!enabledTools.includes("create-durations")) return;
    setSelectedDurationIndex(draggedDurationIndex);
    setDraggedDurationIndex(null);
  });
  var onCreateTimestamp = (0, _useEventCallback.default)(function (time) {
    if (!enabledTools.includes("create-timestamps")) return;
    onChangeTimestamps(timestamps.concat([{
      time: time,
      color: "#888"
    }]));
    setSelectedTimestampIndex(timestamps.length);
  });
  var onRemoveDurationBox = (0, _useEventCallback.default)(function (dgi, boxIndex) {
    var durations = durationGroups[dgi].durations;
    onChangeDurationGroups((0, _seamlessImmutable.setIn)(durationGroups, [dgi, "durations"], [].concat(_toConsumableArray(durations.slice(0, boxIndex)), _toConsumableArray(durations.slice(boxIndex + 1)))));
    if (selectedTimestampIndex !== null) setSelectedTimestampIndex(null);
    if (selectedDurationIndex !== null) setSelectedDurationIndex(null);
  });
  var onClickTimestamp = (0, _useEventCallback.default)(function (ts, tsi) {
    setSelectedTimestampIndex(tsi);
    if (selectedDurationIndex !== null) setSelectedDurationIndex(null);
  });
  var getRandomColorUsingHash = (0, _useGetRandomColorUsingHash.default)();
  var onChangeSelectedItemLabel = (0, _useEventCallback.default)(function (_ref5) {
    var label = _ref5.label,
        color = _ref5.color;

    if (selectedTimestampIndex !== null) {
      onChangeTimestamps((0, _seamlessImmutable.setIn)(timestamps, [selectedTimestampIndex, "label"], label).setIn([selectedTimestampIndex, "color"], color || getRandomColorUsingHash(label)));
    } else if (selectedDurationIndex !== null) {
      var pathToDuration = [activeDurationGroup, "durations", selectedDurationIndex];
      onChangeDurationGroups((0, _seamlessImmutable.setIn)(durationGroups, pathToDuration, _objectSpread(_objectSpread({}, (0, _seamlessImmutable.getIn)(durationGroups, pathToDuration)), {}, {
        label: label
      }, (0, _seamlessImmutable.getIn)(durationGroups, [activeDurationGroup, "color"]) ? {} : {
        color: color || getRandomColorUsingHash(label)
      })));
    }
  });
  var onRemoveTimestamp = (0, _useEventCallback.default)(function (ts, tsi) {
    onChangeTimestamps([].concat(_toConsumableArray(timestamps.slice(0, tsi)), _toConsumableArray(timestamps.slice(tsi + 1))));
  });
  var gridLineMetrics = (0, _getMinorMajorDurationLines.default)(topLevelMatrix, width);
  return /*#__PURE__*/_react.default.createElement(Container, {
    width: width,
    themeColors: themeColors
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    timestamps: timestamps,
    timestampLabels: timestampLabels,
    durationLabels: durationLabels,
    selectedTimestampIndex: selectedTimestampIndex,
    onChangeSelectedItemLabel: onChangeSelectedItemLabel,
    selectedDurationGroupIndex: activeDurationGroup,
    selectedDurationIndex: selectedDurationIndex,
    durationGroups: durationGroups,
    allowCustomLabels: allowCustomLabels,
    onStartPlayback: onStartPlayback,
    onStopPlayback: onStopPlayback,
    isPlayingMedia: isPlayingMedia
  }), /*#__PURE__*/_react.default.createElement(_Timeline.default, {
    timeFormat: timeFormat,
    width: width,
    visibleTimeStart: visibleTimeStart,
    visibleTimeEnd: visibleTimeEnd,
    timestamps: timestamps,
    gridLineMetrics: gridLineMetrics,
    onClickTimestamp: onClickTimestamp,
    onRemoveTimestamp: onRemoveTimestamp
  }), durationGroups.map(function (dg, i) {
    return /*#__PURE__*/_react.default.createElement(_DurationBoxes.default, {
      onClick: function onClick() {
        return setActiveDurationGroup(i);
      },
      onClickBox: function onClickBox(di) {
        setSelectedDurationIndex(di);
        setSelectedTimestampIndex(null);
      },
      onRemoveBox: function onRemoveBox(boxIndex) {
        return onRemoveDurationBox(i, boxIndex);
      },
      key: i,
      active: i === activeDurationGroup,
      color: dg.color,
      width: width,
      label: dg.label,
      isMiscLayer: dg.misc,
      durations: dg.durations,
      visibleTimeStart: visibleTimeStart,
      visibleTimeEnd: visibleTimeEnd
    });
  }), curveGroups.map(function (curves, i) {
    return /*#__PURE__*/_react.default.createElement(_ControllableWave.default, {
      key: i,
      showValues: showValues,
      durations: durationGroups[activeDurationGroup],
      onDragDuration: onDragDuration,
      onDragDurationStart: onDragDurationStart,
      onDragDurationEnd: onDragDurationEnd,
      onCreateTimestamp: onCreateTimestamp,
      durationGroups: durationGroups,
      timestamps: timestamps,
      curves: curves,
      width: width,
      height: graphHeight,
      gridLineMetrics: gridLineMetrics,
      topLevelMatrix: topLevelMatrix,
      setTopLevelMatrix: setTopLevelMatrix,
      timeFormat: timeFormat
    });
  }));
};

exports.MainLayout = MainLayout;
var _default = MainLayout;
exports.default = _default;